import React from "react";
import dayjs from "dayjs";
import "../../../../styles/TrainingDetailsModal.css";

const TrainingDetailsModal = ({ isOpen, onClose, training, onEdit, onDelete }) => {
    if (!isOpen || !training) return null;

    const startTime = dayjs(training.startTime);
    const endTime = dayjs(training.endTime);
    const duration = endTime.diff(startTime, 'minute');

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('tdm-overlay')) {
            onClose();
        }
    };

    return (
        <div className="tdm-overlay" onClick={handleOverlayClick}>
            <div className="tdm-modal">
                {/* Header */}
                <div className="tdm-header">
                    <h2 className="tdm-title">Szczegóły treningu</h2>
                    <p className="tdm-subtitle">
                        {startTime.format('DD.MM.YYYY')} • {startTime.format('HH:mm')} - {endTime.format('HH:mm')}
                    </p>
                    <button className="tdm-close-btn" onClick={onClose}>✕</button>
                </div>

                {/* Content */}
                <div className="tdm-content">
                    {/* Dog Information */}
                    <div className="tdm-section">
                        <h3 className="tdm-section-title">Informacje o psie</h3>
                        <div className="tdm-info-grid">
                            <div className="tdm-info-item">
                                <span className="tdm-label">Imię psa</span>
                                <span className="tdm-value">{training.dogDTO?.name || 'Brak'}</span>
                            </div>
                            <div className="tdm-info-item">
                                <span className="tdm-label">Rasa</span>
                                <span className="tdm-value">{training.dogDTO?.breed || 'Brak'}</span>
                            </div>
                            <div className="tdm-info-item">
                                <span className="tdm-label">Właściciel</span>
                                <span className="tdm-value">{training.dogDTO?.ownerName || 'Brak'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Training Information */}
                    <div className="tdm-section">
                        <h3 className="tdm-section-title">Informacje o treningu</h3>
                        <div className="tdm-info-grid">
                            <div className="tdm-info-item">
                                <span className="tdm-label">Czas trwania</span>
                                <span className="tdm-value">{duration} minut</span>
                            </div>
                            {training.hallName && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">Sala</span>
                                    <span className="tdm-value">{training.hallName}</span>
                                </div>
                            )}
                            {training.serviceName && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">Usługa</span>
                                    <span className="tdm-value">{training.serviceName}</span>
                                </div>
                            )}
                            {training.price && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">Cena</span>
                                    <span className="tdm-value">{training.price} zł</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Additional Info */}
                    {training.additionalInfo?.additionalInfo && (
                        <div className="tdm-section">
                            <h3 className="tdm-section-title">Dodatkowe informacje</h3>
                            <div className="tdm-additional-info">
                                {training.additionalInfo.additionalInfo}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer with Actions */}
                <div className="tdm-footer">
                    <button
                        className="tdm-edit-btn"
                        onClick={() => {
                            onEdit(training);
                            onClose();
                        }}
                    >
                        Edytuj
                    </button>
                    <button
                        className="tdm-delete-btn"
                        onClick={() => {
                            onDelete(training);
                            onClose();
                        }}
                    >
                        Usuń
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TrainingDetailsModal;